import { render, staticRenderFns } from "./SeatingStatus.vue?vue&type=template&id=38f23797&"
import script from "./SeatingStatus.vue?vue&type=script&lang=js&"
export * from "./SeatingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports